/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useIsClient } from "@uidotdev/usehooks"

import OffCanvas from "global/OffCanvas"
import Header from "global/Header"
import Footer from "global/Footer"
import Message from "templates/Message"

import useOffCanvas from "hooks/useOffCanvas";

const Layout = props => {
	const { isOpen, open, close } = useOffCanvas()
	const isClient = useIsClient()

	let { children, containerClassName } = props;

	return (
		<>
			<OffCanvas isOpen={isOpen} close={close}>
				<Header open={open} isOpen={isOpen} close={close} />
				<main className={containerClassName}>{children}</main>
				<Footer />
			</OffCanvas>
			{isClient ? <Message /> : null}
		</>
	)
}

Layout.propTypes = {
	children: PropTypes.node.isRequired,
}

export default Layout
